import { IconButton, Tooltip, useDisclosure } from "@chakra-ui/react";
import { RiPlayListAddLine } from "react-icons/ri";
import AddToWatchlistModal from "components/watchlist/add-to-watchlist-modal/add-to-watchlist-modal";
import usePermission from "hooks/use-permission";

interface AddToWatchlistButtonProps {
  id: number;
}

const AddToWatchlistButton = ({ id }: AddToWatchlistButtonProps) => {
  const hasWatchlistPermission = usePermission("advancedWatchlist");

  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!hasWatchlistPermission) {
    return null;
  }

  return (
    <>
      <Tooltip label="Add to Watchlist">
        <IconButton
          aria-label="Add to Watchlist"
          icon={<RiPlayListAddLine size="18px" />}
          onClick={onOpen}
        />
      </Tooltip>

      <AddToWatchlistModal isOpen={isOpen} onClose={onClose} companies={[id]} />
    </>
  );
};

export default AddToWatchlistButton;
